module.exports = __webpack_public_path__ + "img/LeatherArmorMark2.50e9fcf2.gif";